import { Outlet, useLocation } from 'react-router-dom';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import BackButton from 'components/BackButton';
import { ROUTE_PATHS } from 'routes/constants';

const CardAuthorisations = () => {
  const location = useLocation();

  return (
    <section className={'right-section'}>
      {location.pathname !== ROUTE_PATHS.CARD_AUTHORIZATIONS && <BackButton />}
      <Outlet />
    </section>
  );
};

CardAuthorisations.propTypes = {
  cardsStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  cardsStore: stores.cardsStore
}))(observer(CardAuthorisations));
